import { FunctionComponent, useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { formatFilterEmptyFields } from '@app/utils/filterUtils';
import FilterListIcon from '@mui/icons-material/FilterList';
import { Box } from '@mui/material';
import _debounce from 'lodash/debounce';

import { GenericObject } from '@app/components/common/Table/DefaultTable/types';

import { DebouncedInput } from './DebouncedInput.tsx';

interface ListSearchProps {
  generalFilterLabel?: string;
  generalFilterKey?: string;
  SearchFields?: FunctionComponent;
  handleChangeFilters?(filters: GenericObject): void;
}

export const ListSearch = ({
  SearchFields,
  generalFilterLabel,
  generalFilterKey,
  handleChangeFilters,
}: ListSearchProps) => {
  const [inputValue, setInputValue] = useState('');

  const form = useForm({
    mode: 'onChange',
    defaultValues: {},
  });
  const isValidating = form.formState.isValidating;

  useEffect(() => {
    if (!handleChangeFilters) {
      return;
    }

    //Set null to empty fields to avoid empty strings
    const values = form.getValues();
    formatFilterEmptyFields(values);

    handleChangeFilters({ ...values, [generalFilterKey || 'name']: inputValue });
  }, [inputValue, handleChangeFilters, isValidating, form, generalFilterKey]);

  const handleChangeInputValue = (value: string) => {
    setInputValue(value);
  };

  return (
    <FormProvider {...form}>
      <form style={{ width: '100%', height: '58px', display: 'flex' }}>
        <Box display="flex" alignItems="flex-end" sx={{ width: '30%' }}>
          <Box component="span" mr={2} sx={{ width: '100%' }}>
            <DebouncedInput
              generalFilterLabel={generalFilterLabel as string}
              handleChangeValue={handleChangeInputValue}
            />
          </Box>
        </Box>
        <Box display="flex" alignItems="center" justifyContent="flex-end" sx={{ width: '70%', marginLeft: '20vw' }}>
          {SearchFields && <SearchFields />}
          {SearchFields && (
            <Box component="span" mr={2}>
              <FilterListIcon />
            </Box>
          )}
        </Box>
      </form>
    </FormProvider>
  );
};
